/**
 * Allys Property Amenities Component
 * 
 * Allys-themed wrapper for PropertyAmenities - clean styling
 */

'use client';

import { PropertyAmenities, type PropertyAmenitiesProps } from '@/components/properties';

export function AllysPropertyAmenities(props: PropertyAmenitiesProps) {
  return (
    <div 
      className="relative font-inter"
    >
      <PropertyAmenities {...props} className="" />
    </div>
  );
}
